import { render, staticRenderFns } from "./collectStep2.vue?vue&type=template&id=a21b4e44&scoped=true&"
import script from "./collectStep2.vue?vue&type=script&lang=ts&"
export * from "./collectStep2.vue?vue&type=script&lang=ts&"
import style0 from "./collectStep2.vue?vue&type=style&index=0&id=a21b4e44&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21b4e44",
  null
  
)

export default component.exports